import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { StockAdjustment, StockAdjustmentCreate, StockAdjustmentFilter } from '../data/stockAdjustment';

export function createStockAdjustmentService(client: AxiosInstance) {
  return createCrudService<StockAdjustment, StockAdjustmentCreate, StockAdjustmentFilter>(
    client,
    '/StockAdjustment',
    'stockAdjustmentId'
  );
}

export type StockAdjustmentService = CrudService<
  StockAdjustment,
  StockAdjustmentCreate,
  StockAdjustmentFilter
>;
